<template>
    <div class="layout">
        <div
            v-if="!!$slots['top']"
            class="layout__top">
            <slot name="top" />
        </div>
        <div
            class="layout__container"
            :class="defineLayoutContainerClass">
            <div class="row u-entire-height">
                <div
                    class="layout__content"
                    :class="defineLayoutContentClass">
                    <slot name="content" />
                </div>
                <aside
                    class="layout__aside col-default-3 col-default-offset-1 col-tablet-12 col-tablet-offset-0"
                    v-if="type === 'two-columns'"
                >
                    <slot name="aside" />
                </aside>
            </div>
        </div>
        <scroll-top-btn />
    </div>
</template>

<script setup>
import NavigationLeft from '@/components/NavigationLeft'
import ScrollTopBtn from '@/components/ScrollTopBtn/ScrollTopBtn.vue'
import { computed } from 'vue'

const props = defineProps({
    type: {
        type: String,
        default: 'one-column',
        validator: (prop) => ['wide', 'one-column'].includes(prop)
    }
})

const defineLayoutContentClass = computed(() => {
    return [
        props.type === 'two-columns' ? 'col-default-8 col-tablet-12' : 'col-default-12',
        { 'layout__content--wide': props.type === 'wide' }
    ]
})
const defineLayoutContainerClass = computed(() => {
    return {
        'container': props.type !== 'wide',
        'layout__container--two-columns': props.type === 'two-columns'
    }
})
</script>

<style lang="scss">
.layout {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;

    &__container {
        flex-grow: 1;
        overflow: clip;
        @include margin-level(bottom, XL);

        &--two-columns {
            @include margin-level(bottom, L);
        }
    }

    &__top {
        flex-shrink: 0;
        flex-grow: 0;
    }

    &__content,
    &__aside {
        @include padding-level(bottom, XL);
        @include padding-level(top, 2XL);
        // @include margin-level(top, XL, false, true);
    }

    &__content + &__aside{
        @include breakpoint(tablet){
            margin-top: 0;
        }
    }

    &__aside {
        @include breakpoint(tablet) {
            padding-top: 0;
        }
    }

    &__content {
        &--wide {
            padding: 0;
        }
    }
}
body.wide {
    & .layout {
        &__container{
            margin-bottom: 0;
        }
    }
}

body.wide {
    .layout__container > .row {
        margin-left: 0;
        margin-right: 0;
    }
}

body.green.gradient-start {
    .layout__top {
        position: relative;

        &:before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            transform: translateY(50%);
            width: 100%;
            height: 192px;
            background: linear-gradient(360deg, #026958 39.22%, rgba(2, 105, 88, 0.99) 43.27%, rgba(2, 105, 88, 0.96) 47.32%, rgba(2, 105, 88, 0.92) 51.37%, rgba(2, 105, 88, 0.85) 55.42%, rgba(2, 105, 88, 0.77) 59.48%, rgba(2, 105, 88, 0.67) 63.53%, rgba(2, 105, 88, 0.56) 67.58%, rgba(2, 105, 88, 0.44) 71.63%, rgba(2, 105, 88, 0.33) 75.69%, rgba(2, 105, 88, 0.23) 79.74%, rgba(2, 105, 88, 0.15) 83.79%, rgba(2, 105, 88, 0.08) 87.84%, rgba(2, 105, 88, 0.04) 91.9%, rgba(2, 105, 88, 0.01) 95.95%, rgba(2, 105, 88, 0) 100%);
            pointer-events: none;
            z-index: 1;
        }
        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            transform: translateY(100%);
            width: 100%;
            height: 192px;
            background: linear-gradient(180deg, #026958 39.22%, rgba(2, 105, 88, 0.99) 43.27%, rgba(2, 105, 88, 0.96) 47.32%, rgba(2, 105, 88, 0.92) 51.37%, rgba(2, 105, 88, 0.85) 55.42%, rgba(2, 105, 88, 0.77) 59.48%, rgba(2, 105, 88, 0.67) 63.53%, rgba(2, 105, 88, 0.56) 67.58%, rgba(2, 105, 88, 0.44) 71.63%, rgba(2, 105, 88, 0.33) 75.69%, rgba(2, 105, 88, 0.23) 79.74%, rgba(2, 105, 88, 0.15) 83.79%, rgba(2, 105, 88, 0.08) 87.84%, rgba(2, 105, 88, 0.04) 91.9%, rgba(2, 105, 88, 0.01) 95.95%, rgba(2, 105, 88, 0) 100%);
            pointer-events: none;
            z-index: 1;
        }
    }
}
</style>
